import { render } from "./HeaderSubsection.vue?vue&type=template&id=65ca2875&scoped=true"
import script from "./HeaderSubsection.vue?vue&type=script&lang=js"
export * from "./HeaderSubsection.vue?vue&type=script&lang=js"

import "./HeaderSubsection.vue?vue&type=style&index=0&id=65ca2875&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65ca2875"]])

export default __exports__